import { useSelector } from 'react-redux'
import { CollapseInterface } from '../../../Interfaces/CollapseInterface'
import { CollapseGroup } from '../../../share/Components'
import ListSamad from './ListSamad'
import { ReducerType } from '../../../storeManager/ReducerType'
import { LoginInterface } from '../../../Interfaces/LoginInterface'
import ListSamadPeresentation from './ListSamadPeresentation'
import ListBill from './ListBill'

const IHIO = () => {
  const user = useSelector<ReducerType, LoginInterface>(
    (state) => state.reducerUser
  )
  const center = useSelector<ReducerType, CenterViewModel>(
    (state) => state.reducerCenter
  )
  const items: Array<CollapseInterface> = [
    {
      title: 'تاریخچه تجویز',
      element: <ListSamad centerId={center.id} token={user.token} />,
      isShow: true,
      className: {
        className: 'bg-white py-2 shadow-inner',
        titleClass: 'text-xs font-bold',
        iconClass: '!text-3xl text-secondary',
      },
      icon: 'rayteb-serve',
    },
    {
      title: 'تاریخچه ارائه',
      element: (
        <ListSamadPeresentation centerId={center.id} token={user.token} />
      ),
      isShow: true,
      className: {
        className: 'bg-white py-2 shadow-inner',
        titleClass: 'text-xs font-bold',
        iconClass: '!text-3xl text-secondary',
      },
      icon: 'rayteb-prescription',
    },
    {
      title: 'صورت حساب ها',
      element: <ListBill centerId={center.id} token={user.token} />,
      isShow: true,
      className: {
        className: 'bg-white py-2 shadow-inner',
        titleClass: 'text-xs font-bold',
        iconClass: '!text-3xl text-secondary',
      },
      icon: 'rayteb-payment',
    },
  ]
  return (
    <>
      <CollapseGroup
        items={items}
        removeElementAfterChange={true}
        className='pb-24'
      />
    </>
  )
}

export default IHIO
